<template>
  <div class="upload-image">
      <div class="upload-image" :style="{ backgroundImage: 'url(' + value + ')' }" @click="triggerUpload">
        <span v-if="!uploading && !value">Foto hochladen
ID / Pass /
Führerausweis</span>
        <span v-if="uploading">  {{ progress }}%</span>
      </div>
      <input type="file" ref="uploader" accept="image/*" @change="onInputUpload"/>
  </div>
</template>

<script>
  import {uploadFile} from "../services/upload";

  export default {
    name: 'UploadImage',

    props: {
      value: {
        type: String,
        default: null

      }
    },

    data: () => ({
      uploadError: null,
      uploading: false,
      progress: 0,
      slide: 0
    }),

    methods: {
      triggerUpload() {
        if (!this.uploading) {
          this.$refs.uploader.click()
          this.uploadError = null
        }
      },
      onInputUpload(e) {
        let file = e.target.files[0];
        if (file) {
          this.upload(file)
        }
      },
      upload(file) {
        let fileName = file.name;
        let key = `images/${Date.now()}_${fileName}`;

        this.uploading = true;
        this.progress = 0;

        uploadFile(key, file)
          .then(upload => {
            upload.on('httpUploadProgress', (progress) => {
              this.progress = parseInt(((progress.loaded / progress.total) * 100).toFixed(0));
            });

            upload.promise()
              .then(res => {
                this.$emit('input', res.Location);
                this.uploading = false;
              })
              .catch(err => {
                this.uploading = false;
              })
          });

      },
    },
  }
</script>

<style lang="scss">
  @import "UploadImage";
</style>
